<template>
  <div :style="{ position: 'relative' }">
    <Loading :active.sync="loading" :isFullPage="false"></Loading>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />

    <div class="p-d-flex p-jc-row p-ai-center p-mb-2">
      <div><b>Grupo: {{ group ? group.name : '' }}</b></div>

      <div class="p-ml-auto">
        <Dropdown
          v-model="selectAllOption"
          @input="handleSelectAllChange"
          :options="selectAllOptions"
          optionValue="value"
          optionLabel="label"
          placeholder="Ações"
          class="select-all-dropdown"
          :showClear="false"
        />
      </div>
    </div>

    <div v-for="parentCategory in organizedCategories" :key="parentCategory.id">

      <div
        class="box-category-header"
        @click="toggleParentCategory(parentCategory.id)"
      >
        <div class="p-d-flex p-jc-between p-ai-center">
          <div class="p-d-flex p-ai-center">
            <i
              :class="[
                'pi',
                expandedParentCategories[parentCategory.id] ? 'pi-chevron-down' : 'pi-chevron-right'
              ]"
              class="parent-category-icon"
            ></i>
            <div class="p-ml-2">
              <b>{{ parentCategory.name }}</b>
            </div>
            <span class="parent-category-count p-ml-2">({{ getTotalAclsCount(parentCategory) }})</span>
          </div>

          <div class="p-d-flex p-ai-center parent-category-actions" @click.stop>
            <span class="p-mr-2 check-all-label">Selecionar todos:</span>
            <InputSwitch
              :value="isParentCategoryFullyChecked(parentCategory)"
              @input="toggleAllInParentCategory(parentCategory, $event)"
              class="switch-category-check-all"
            />
          </div>
        </div>
      </div>

      <div
        v-show="expandedParentCategories[parentCategory.id]"
        class="box-category-content"
      >

        <div v-if="parentCategory.acls && parentCategory.acls.length > 0" class="parent-direct-acls p-mb-2">
          <div
            class="p-d-flex p-jc-row p-ai-center p-ml-4 acls-list item-acls"
            v-for="acl in parentCategory.acls"
            :key="acl.id"
          >
            <div>
              <InputSwitch
                v-model="groupAcls[acl.id]"
                :id="acl.id"
                style="top: 3px;"
                v-bind:class="[
                  'switch-childs acl-group',
                ]"
              />
            </div>
            <div class="p-ml-2">{{ acl.name }} | {{ acl.alias }}</div>
          </div>
        </div>

        <div v-for="childCategory in parentCategory.children" :key="childCategory.id">
          <div
            class="box-category-header p-ml-2 box-category-header-child"
            v-if="childCategory.acls.length > 0"
            @click="toggleCategory(childCategory.id)"
          >
            <div class="p-d-flex p-jc-between p-ai-center">
              <div class="p-d-flex p-ai-center">
                <i
                  :class="[
                    'pi',
                    expandedCategories[childCategory.id] ? 'pi-chevron-down' : 'pi-chevron-right'
                  ]"
                  class="child-category-icon"
                ></i>
                <div class="p-ml-2">
                  <b>{{ childCategory.name }}</b>
                </div>
                <span class="child-category-count p-ml-2">({{ childCategory.acls.length }})</span>
              </div>

              <div class="p-d-flex p-ai-center child-category-actions" @click.stop>
                <span class="p-mr-2 check-all-label">Selecionar todos:</span>
                <InputSwitch
                  :value="isCategoryFullyChecked(childCategory)"
                  @input="toggleAllInCategory(childCategory, $event)"
                  class="switch-category-check-all"
                />
              </div>
            </div>
          </div>

          <div
            v-show="expandedCategories[childCategory.id]"
            class="box-category-content p-ml-2"
            v-if="childCategory.acls.length > 0"
          >
            <div
              class="p-d-flex p-jc-row p-ai-center p-ml-3 acls-list item-acls"
              v-for="acl in childCategory.acls"
              :key="acl.id"
            >
              <div>
                <InputSwitch
                  v-model="groupAcls[acl.id]"
                  :id="acl.id"
                  style="top: 3px;"
                  v-bind:class="[
                    'switch-childs acl-group',
                  ]"
                />
              </div>
              <div class="p-ml-2">{{ acl.name }} | {{ acl.alias }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <divider />
    <div class="p-d-flex p-jc-end">
      <Button
        :label="'Guardar'"
        icon="pi pi-check"
        class="p-button-success p-mr-2"
        @click="save"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-danger"
        @click="cancel"
      />
    </div>
  </div>
</template>

<script>
import aclsService from "../../services/acls.service";
import loading from "vue-loading-overlay";

export default {
  name: "setGroupAcls",
  components: {
    Loading: loading,
  },
  props: ["group"],
  watch: {
    group() {
      if (this.group != undefined) {
        this.getInfo();
      }
    },
  },
  data() {
    return {
      loading: false,
      categoriesAcl: [],
      groupAcls: [],
      expandedCategories: {},
      expandedParentCategories: {},
      organizedCategories: [],
      selectAllOption: null,
      selectAllOptions: [
        { label: 'Selecionar Tudo', value: 'select_all' },
        { label: 'Desselecionar Tudo', value: 'deselect_all' },
        { label: 'Expandir Todas', value: 'expand_all' },
        { label: 'Fechar Todas', value: 'collapse_all' }
      ]
    };
  },
  productService: null,
  async created() {
    if (this.group != undefined) {
      this.getInfo();
    }
  },
  methods: {
    handleSelectAllChange(value) {
      switch(value) {
        case 'select_all':
          this.selectAllAcls(true);
          break;
        case 'deselect_all':
          this.selectAllAcls(false);
          break;
        case 'expand_all':
          this.expandAllCategories(true);
          break;
        case 'collapse_all':
          this.expandAllCategories(false);
          break;
      }

      this.selectAllOption = null;
    },

    selectAllAcls(checked) {
      this.organizedCategories.forEach(parentCategory => {
        if (parentCategory.acls) {
          parentCategory.acls.forEach(acl => {
            this.$set(this.groupAcls, acl.id, checked);
          });
        }

        if (parentCategory.children) {
          parentCategory.children.forEach(childCategory => {
            childCategory.acls.forEach(acl => {
              this.$set(this.groupAcls, acl.id, checked);
            });
          });
        }
      });
    },

    expandAllCategories(expanded) {
      Object.keys(this.expandedParentCategories).forEach(parentId => {
        this.$set(this.expandedParentCategories, parentId, expanded);
      });

      Object.keys(this.expandedCategories).forEach(childId => {
        this.$set(this.expandedCategories, childId, expanded);
      });
    },

    async getInfo() {
      this.loading = true;
      this.groupAcls = await this.getGroupAcls();
      this.categoriesAcl = await aclsService.getCategoriesAcls();
      this.organizeCategories();
      this.initializeExpandedCategories();
      return (this.loading = false);
    },

    organizeCategories() {
      const parentCategories = this.categoriesAcl.filter(cat => cat.parent_id === null);
      const childCategories = this.categoriesAcl.filter(cat => cat.parent_id !== null);

      this.organizedCategories = parentCategories.map(parent => {
        const children = childCategories.filter(child => child.parent_id === parent.id);
        return {
          ...parent,
          children: children
        };
      });
    },

    initializeExpandedCategories() {
      const expandedParents = {};
      const expandedChildren = {};

      this.organizedCategories.forEach(parent => {
        expandedParents[parent.id] = false;

        parent.children.forEach(child => {
          if (child.acls.length > 0) {
            expandedChildren[child.id] = false;
          }
        });
      });

      this.expandedParentCategories = expandedParents;
      this.expandedCategories = expandedChildren;
    },

    toggleParentCategory(parentId) {
      this.$set(this.expandedParentCategories, parentId, !this.expandedParentCategories[parentId]);
    },

    toggleCategory(categoryId) {
      this.$set(this.expandedCategories, categoryId, !this.expandedCategories[categoryId]);
    },

    getTotalAclsCount(parentCategory) {
      let count = parentCategory.acls ? parentCategory.acls.length : 0;
      if (parentCategory.children) {
        count += parentCategory.children.reduce((sum, child) => sum + child.acls.length, 0);
      }
      return count;
    },

    isParentCategoryFullyChecked(parentCategory) {
      let allAcls = [];

      if (parentCategory.acls) {
        allAcls = [...allAcls, ...parentCategory.acls];
      }

      if (parentCategory.children) {
        parentCategory.children.forEach(child => {
          allAcls = [...allAcls, ...child.acls];
        });
      }

      return allAcls.every(acl => this.groupAcls[acl.id]);
    },

    toggleAllInParentCategory(parentCategory, checked) {
      if (parentCategory.acls) {
        parentCategory.acls.forEach(acl => {
          this.$set(this.groupAcls, acl.id, checked);
        });
      }

      if (parentCategory.children) {
        parentCategory.children.forEach(child => {
          child.acls.forEach(acl => {
            this.$set(this.groupAcls, acl.id, checked);
          });
        });
      }
    },

    isCategoryFullyChecked(category) {
      return category.acls.every(acl => this.groupAcls[acl.id]);
    },

    toggleAllInCategory(category, checked) {
      category.acls.forEach(acl => {
        this.$set(this.groupAcls, acl.id, checked);
      });
    },

    async getGroupAcls() {
      return aclsService.getGroupAcls(this.group.id).then((response) => {
        let groupAcls = {};
        response.map((acl) => {
          groupAcls[acl.id] = true;
        });
        return groupAcls;
      });
    },

    cancel() {
      return this.$emit("cancel");
    },

    save() {
      this.loading = true;
      let aclsChecked = [];
      for (const aclId in this.groupAcls) {
        if (this.groupAcls[aclId] === true) {
          aclsChecked.push(parseInt(aclId));
        }
      }
      return aclsService
        .setGroupAcls(this.group.id, { acls: aclsChecked })
        .then((response) => {
          this.loading = false;
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao alterar as acls ao grupo",
              detail: "",
              life: 3000,
            });
          }

          this.$toast.add({
            severity: "success",
            summary: `Acls do grupo alteradas com sucesso`,
            detail: ``,
            life: 3000,
          });

          return this.$emit("setGroupAclsOk");
        });
    },
  },
};
</script>

<style>
.select-all-dropdown {
  min-width: 150px;
}

.box-category-header {
  background-color: #fff;
  color: #333;
  font-size: 18px;
  padding: 7px 20px;
  cursor: pointer;
  border-radius: 6px;
  margin-bottom: 6px;
  border: 1px solid #9f9f9f;
  transition: background-color 0.2s ease;
}

.box-category-header:hover {
  background-color: #eee;
}

.box-category-header-child {
  background-color: #f2f2f2;
  border: none;
}

.parent-category-icon {
  font-size: 14px;
  color: #333;
  transition: transform 0.2s ease;
}

.parent-category-count {
  font-size: 14px;
  opacity: 0.9;
  font-weight: normal;
}

.parent-category-actions {
  gap: 10px;
}

.switch-childs .p-inputswitch-slider {
  background-color: #6c757d !important;
}

.switch-category-check-all .p-inputswitch-slider {
  background-color: #6c757d !important;
}

.switch-category-check-all.p-inputswitch-checked .p-inputswitch-slider {
  background-color: #dc3545 !important;
}

.box-category-content {
  border-left: 2px solid #333;
  margin-bottom: 10px;
  padding: 4px 0;
  animation: slideDown 0.3s ease;
}

.child-category-icon {
  font-size: 12px;
  color: #333;
  transition: transform 0.2s ease;
}

.child-category-count {
  font-size: 12px;
  opacity: 0.8;
  font-weight: normal;
}

.child-category-actions {
  gap: 8px;
}

.acls-list {
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  transition: background-color 0.2s ease;
}

.acls-list:last-child {
  border-bottom: none;
}

.acls-list:hover {
  background-color: #f1f3f4;
}

.item-acls:hover {
  background-color: rgba(44, 90, 160, 0.1);
}

.check-all-label {
  font-size: 12px;
  font-weight: normal;
  color: inherit;
}

.p-inputswitch-checked.acl-group .p-inputswitch-slider {
  background-color: #dc3545 !important;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 1000px;
  }
}

@media (max-width: 768px) {
  .box-category-header {
    font-size: 16px;
  }

  .box-category-header {
    margin: 5px 10px 2px;
    font-size: 14px;
  }

  .check-all-label {
    display: none;
  }

  .select-all-dropdown {
    min-width: 120px;
  }
}
</style>